/**
 * Sets an element's vertical padding equal to one of its grid columns' width.
 *
 * Markup: <div class="container-grid ... py-16" data-py-col> … </div>
 *
 * The column width is dynamic (viewport, gaps, max-width), so it's read from the
 * computed grid track. Only applied from `lg` up, where the 12-column inset
 * layout exists; below that the element's own `py-*` class is used (inline
 * padding is cleared).
 */
function applyColumnPadding() {
  const isLg = window.matchMedia("(min-width: 1024px)").matches;

  document.querySelectorAll("[data-py-col]").forEach((grid) => {
    if (!isLg) {
      grid.style.paddingTop = "";
      grid.style.paddingBottom = "";
      return;
    }

    const tracks = getComputedStyle(grid)
      .gridTemplateColumns.split(" ")
      .filter(Boolean);
    const colWidth = parseFloat(tracks[0]);

    if (tracks.length >= 2 && !Number.isNaN(colWidth)) {
      grid.style.paddingTop = `${colWidth}px`;
      grid.style.paddingBottom = `${colWidth}px`;
    } else {
      grid.style.paddingTop = "";
      grid.style.paddingBottom = "";
    }
  });
}

let resizeTimer;
function onResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(applyColumnPadding, 150);
}

window.addEventListener("load", applyColumnPadding);
window.addEventListener("resize", onResize);
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(applyColumnPadding);
}
